import(/* webpackMode: "eager" */ "/app/app/storefront.css");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalRouteProgress"] */ "/app/core/components/GlobalRouteProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/core/components/providers/session-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebMCPInitializer"] */ "/app/core/components/providers/WebMCPInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToasterLazy"] */ "/app/core/components/ui/ToasterLazy.tsx");
